import { isValidJSONObject } from '@ion/mrdash';

export const JSON_OBJECT_VALIDATION_MESSAGE = 'Must be a valid JSON object';

export default function jsonObject(value) {
  return isValidJSONObject(value) || JSON_OBJECT_VALIDATION_MESSAGE;
}
